<script setup lang="ts">
import InformationBaseCard from '@/components/Cards/InformationBaseCard.vue'
import EditableTypedInput from '@/components/Fields/EditableTypedInput.vue'
import { StackLayout } from '@/components/Layouts'
import { localFallback } from '@/locales/langUtils'
import type { ExtendedPrimitives } from '@/types/ExtendedPrimitives'
import type { ConfigType, PartnerConfigModel } from '@/types/models/PartnerConfigModel'
import type { PartnerModel } from '../../../../types/partners/PartnerModel'

type Props = {
    partnerConfigData?: PartnerModel
    partnerConfig?: Record<string, ConfigType | string>
    partnerConfigValues?: Record<string, ExtendedPrimitives>
    isInEditMode: boolean
}
defineProps<Props>()
type Emits = {
    (e: 'update', value: Partial<PartnerConfigModel>): void
}
defineEmits<Emits>()
</script>

<template>
    <InformationBaseCard
        :label="`${$t('event.detail.informations.partnerConfigTitle')} : ${
            partnerConfigData?.name
        }`"
        class="full-width fit-height">
        <StackLayout direction="column" :gap="8" class="full-width" v-if="partnerConfig">
            <EditableTypedInput
                v-for="([itemKey, itemValue], key) in Object.entries(partnerConfig)"
                :key="key"
                :value="partnerConfigValues?.[itemKey]"
                :label="
                    (itemValue as ConfigType)?.label
                        ? localFallback((itemValue as ConfigType)?.label) ?? itemKey
                        : itemKey
                "
                :dataType="(itemValue as ConfigType)?.type ?? itemValue"
                :isInEditMode="isInEditMode"
                @change="$emit('update', { ...(partnerConfigValues ?? {}), [itemKey]: $event })" />
        </StackLayout>
        <StackLayout direction="column" :gap="8" class="full-width" v-else-if="partnerConfigValues">
            <EditableTypedInput
                v-for="([itemKey, itemValue], key) in Object.entries(partnerConfigValues)"
                :key="key"
                :value="itemValue"
                :label="itemKey"
                dataType="string"
                :isInEditMode="isInEditMode"
                @change="$emit('update', { ...partnerConfigValues, [itemKey]: $event })" />
        </StackLayout>
    </InformationBaseCard>
</template>
